import { marked } from 'marked';

// Configure marked to open links in a new tab
const renderer = new marked.Renderer();
const originalLinkRenderer = renderer.link;
renderer.link = (href, title, text) => {
  const html = originalLinkRenderer.call(renderer, href, title, text);
  return html.replace(/^<a/, '<a target="_blank" rel="noopener noreferrer"');
};

marked.setOptions({
  renderer: renderer,
});

export function useMarkdown() {
  const renderMarkdown = (text) => {
    if (!text) return '';
    return marked(text);
  };

  return { renderMarkdown };
}